
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/scheduling-and-re-scheduling",
      function () {
        return require("private-next-pages/ai/scheduling-and-re-scheduling.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/scheduling-and-re-scheduling"])
      });
    }
  